import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useListingSection from './useListingSection';

import styles
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';

const Listing = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll } = useListingSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Listing }
      header={ (
        <FilterSectionHeader
          title="LISTING"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="listingFiltersAllCheckbox"
            />
          ) }
        />
      ) }
    >
      <div className={ styles.columns2 }>
        { items.map((item) => (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ item.name }
              checked={ selectedValues.includes(item.value) }
              onChange={ () => toggle(item.value) }
              dataTest={ `checkbox-listing-${ item.value }` }
            />
          </FilterItem>
        )) }
      </div>
    </FilterSection>
  );
};

export default Listing;
